<template>
  <el-dialog :visible.sync="visible" class="campaign-withdrawal-modal" top="0">
    <div class="">
      <div class="content mb-10">
        <p class="font-bold text-xl text-black my-3.5">
          {{ isNotice ? $t('tradingContest.notice') : $t('tradingContest.confirmation') }}
        </p>
        <i18n path="tradingContest.withdrawDesc1" tag="span" class="text-grayG4 leading-6">
          <template v-slot:tradingContest>
            <span class="font_bold">{{ campaignName }}</span>
          </template>
        </i18n>
        &nbsp;
        <span v-if="!isNotice" class="text-grayG4 leading-6 mt-3">{{ $t('tradingContest.withdrawDesc2') }} </span>
        <span class="text-grayG4 leading-6 mt-3">{{ $t('tradingContest.withdrawDesc3') }}</span>
      </div>
      <div slot="footer" class="mb-10">
        <span class="dialog-footer">
          <SecondaryButton padding="px-10" height="h-12" width="min-w-42" :onClick="handleClose" class="dialog-btn"
            >{{ $t('tradingContest.back') }}
          </SecondaryButton>
          <PrimaryButton padding="px-10" height="h-12" width="min-w-42" :onClick="handleConfirm" class="dialog-btn">{{
            $t('tradingContest.confirm')
          }}</PrimaryButton>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import PrimaryButton from '@/components/buttons/primaryButton/PrimaryButton.vue';
import SecondaryButton from '@/components/buttons/secondaryButton/SecondaryButton.vue';
import promotionMixin from '@/mixins/promotion';

export default {
  name: 'CampaignWithdrawalModal',
  mixins: [promotionMixin],
  props: {
    campaignWithdrawalModalVisible: Boolean,
    isNotice: {
      type: Boolean,
      default: true
    },
    mt4account: [String, Number]
  },
  components: { PrimaryButton, SecondaryButton },
  data() {
    return {
      visible: false,
      campaignName: null
    };
  },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    }
  },
  watch: {
    campaignWithdrawalModalVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.$emit('update:campaignWithdrawalModalVisible', bool);
    },
    mt4account(val) {
      const filteredTCs = this.participatedTC.filter(campaign =>
        campaign.participantAccount?.some(account => account.mt4Account === parseInt(val))
      );

      const getTitleByLang = lang =>
        filteredTCs
          .map(tc => tc.clientPortalSettings?.find(item => item.languageCode === lang)?.title)
          .filter(Boolean)
          .join(', ');

      this.campaignName = getTitleByLang(this.lang) || getTitleByLang('en_US');
    }
  },
  methods: {
    // as the x button not working as expected
    handleClose() {
      this.visible = !this.visible;
    },
    handleConfirm() {
      this.$emit('proceed', true);
      this.handleClose();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/withdraw/campaignWithdrawalModal.scss';
</style>
